import { render, staticRenderFns } from "./menuTree.vue?vue&type=template&id=1afe6f4d&scoped=true"
import script from "./menuTree.vue?vue&type=script&lang=js"
export * from "./menuTree.vue?vue&type=script&lang=js"
import style0 from "./menuTree.vue?vue&type=style&index=0&id=1afe6f4d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe6f4d",
  null
  
)

export default component.exports